import React from 'react';
import BaseComponent from '../system/base';
import UserContext from '../../context/userContext';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PubSub from 'pubsub-js';

class SideBar extends BaseComponent {
  static contextType = UserContext;

  state = {
    open: false,
  };

  componentDidMount() {
    PubSub.subscribe('nav-toggle', (msg, data) => {
      this.setState({open: data})
    });
  }

  render() {
    return (
      <Drawer open={this.state.open} onClose={() => {
        this.setState({open: false});
      }}>
        <div style={{backgroundColor: "#1A1A1A", color: "white"}}>
          <List>
            <ListItem button>
              <ListItemIcon><img src="/images/content/banner/popitLogoTop.png" alt="adsf"/></ListItemIcon>
              <ListItemText primary={"asdfadsfafds"} />
            </ListItem>
            <ListItem button onClick={() => {
              //todo
              // this.context.firebase.default.auth().signOut();
              // this.setState(this.defaultUserState());
            }}>
              <ListItemIcon><img src="/images/content/banner/popitLogoTop.png" alt="adsf"/></ListItemIcon>
              <ListItemText primary={"logout"} />
            </ListItem>
          </List>
          <Divider />
        </div>
      </Drawer>
    );
  }
}


export default SideBar


// WEBPACK FOOTER //
// ./src/components/sidebar/index.js